// 排行榜
const rankingRouter = {
  path: '/ranking',
  name: 'Ranking',
  component: () => import('@/views/rankingList/index')
}
export default rankingRouter
